import { createFileRoute } from '@tanstack/react-router'
import { AvailableChallengesPage } from '../../components'

export const Route = createFileRoute('/challenges/available')({
  component: () => <AvailableChallengesPage />,
})
